export default __webpack_public_path__ + "static/media/Nehfu.283df90a.jpg";